export default __webpack_public_path__ + "static/sphere-67d2b9fd04ecfe4e9679451a6f79c9c4.png";